import { Button, Divider, Group, Menu } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconChevronDown } from "@tabler/icons-react";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { updateProfile } from "../../api/UserAPI";
import { useState } from "react";

const LanguageChanger = ({ header, isStatic }) => {
  const lang = useLanguage((s) => s.language);
  const changeLanguage = useLanguage((s) => s.changeLanguage);
  const [loading, setLoading] = useState(false);

  const isMobile = window.innerWidth < 768

  header = isMobile || header

  const langs = [
    {
      value: "FRA",
      label: "Français",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_France.svg",
    },
    {
      value: "ENG",
      label: "English",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_the_United_Kingdom_%283-5%29.svg",
    },
    {
      value: "SPA",
      label: "Español",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg",
    },
    {
      value: "ITA",
      label: "Italiano",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg",
    },
    {
      value: "DEU",
      label: "Deutsch",
      flagUrl:
        "https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg",
    },
  ];

  const activeLang = langs.find((x) => x.value === lang.id);

  const handleChange = (value) => {
    const profile = useProfileStore.getState().profile;
    if (header && !isMobile) {
      setLoading(true);
      updateProfile(profile.id, { language: value })
        .then(() => {
          changeLanguage(value);
        })
        .finally(() => setLoading(false));
    } else {
      changeLanguage(value);
    }
  };

  return (
    <Menu withArrow offset={0}>
      <Menu.Target>
        <Button
          leftSection={
            !header && (
              <img
                src={activeLang.flagUrl}
                width={24}
                alt="flag"
                rel="noreferrer"
                referrerPolicy="no-referrer"
              />
            )
          }
          variant={header ? "subtle" : "white"}
          size="md"
          rightSection={!header && <IconChevronDown size={18} />}
          pos={isStatic ? "static" : isMobile ? "absolute" : header ? "relative" : "absolute"}
          top={header ? 0 : 32}
          right={header ? 0 : 48}
          w={header ? "auto" : 160}
          disabled={!!useSessionStore.getState().user_switch}
          loading={loading}
        >
          {header ? (
            <img
              src={activeLang.flagUrl}
              width={24}
              alt="flag"
              rel="noreferrer"
              referrerPolicy="no-referrer"
            />
          ) : (
            activeLang.label
          )}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        {langs.map((item, index) => (
          <div key={item.value}>
            {index !== 0 && <Divider key={item.value} my={4} opacity={0.5} />}
            <Menu.Item
              key={item.value}
              onClick={() => handleChange(item.value)}
            >
              <Group fz={15}>
                <img
                  src={item.flagUrl}
                  width={24}
                  alt="flag"
                  rel="noreferrer"
                  referrerPolicy="no-referrer"
                />
                {item.label}
              </Group>
            </Menu.Item>
          </div>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageChanger;
